<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>学生信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>学号：</p>
                    <a-input class="input" v-model="info.studentNo" disabled />
                </div>
                <div class="input-box">
                    <p>姓名：</p>
                    <a-input class="input" v-model="info.studentName" disabled />
                </div>
                <div class="input-box">
                    <p>姓名拼音：</p>
                    <a-input class="input" v-model="info.studentNameSpell" disabled />
                </div>
                <div class="input-box">
                    <p>备注姓名：</p>
                    <a-input class="input" v-model="info.remarkName" disabled />
                </div>
                <div class="input-box">
                    <p>性别：</p>
                    <a-input class="input" v-model="info.genderCode" disabled />
                </div>
                <div class="input-box">
                    <p>是否留学生：</p>
                    <a-input class="input" :value="info.isInternational?'是':'否'" disabled />
                </div>
                <div class="input-box">
                    <p>国籍代码：</p>
                    <a-input class="input" v-model="info.nationalityCode" disabled />
                </div>
                <div class="input-box">
                    <p>籍贯代码：</p>
                    <a-input class="input" v-model="info.nativePlaceCode" disabled />
                </div>
                <div class="input-box">
                    <p>出生日期：</p>
                    <a-input class="input" v-model="info.birthday" disabled />
                </div>
                <div class="input-box">
                    <p>婚姻状态：</p>
                    <a-input class="input" v-model="info.maritalCode" disabled />
                </div>
                <div class="input-box">
                    <p>民族：</p>
                    <a-input class="input" v-model="info.nationGroupCode" disabled/>
                </div>
                <div class="input-box">
                    <p>入党或团日期：</p>
                    <a-input class="input" v-model="info.joinPartyDate" disabled/>
                </div>
                <div class="input-box">
                    <p>火车到站省份：</p>
                    <a-input class="input" v-model="info.trainArrivalProvince" disabled/>
                </div>
                <div class="input-box">
                    <p>火车到站站点：</p>
                    <a-input class="input" :value="info.trainArrivalStation" disabled/>
                </div>
                <div class="input-box">
                    <p>家庭地址邮政编码：</p>
                    <a-input class="input" v-model="info.homePostCode" disabled/>
                </div>
                <div class="input-box">
                    <p>家庭地址：</p>
                    <a-input class="input" v-model="info.homeAddress" disabled/>
                </div>
                <div class="input-box">
                    <p>户口所在省市：</p>
                    <a-input class="input" v-model="info.registeredProvince" disabled/>
                </div>
                <div class="input-box">
                    <p>电子邮箱：</p>
                    <a-input class="input" v-model="info.email" disabled/>
                </div>
                <div class="input-box">
                    <p>手机号码：</p>
                    <a-input class="input" v-model="info.mobilePhone" disabled/>
                </div>
                <div class="input-box">
                    <p>联系地址：</p>
                    <a-input class="input" :value="info.contactAddress" disabled/>
                </div>
                <div class="input-box">
                    <p>工作单位：</p>
                    <a-input class="input" :value="info.worUnit" disabled/>
                </div>
                <div class="input-box">
                    <p>工作单位邮政编码：</p>
                    <a-input class="input" :value="info.workUnitPostCode" disabled/>
                </div>
                <div class="input-box">
                    <p>工作单位通讯地址：</p>
                    <a-input class="input" v-model="info.workUnitAddress" disabled/>
                </div>
                <div class="input-box">
                    <p>年级：</p>
                    <a-input class="input" v-model="info.grade" disabled/>
                </div>
                <div class="input-box">
                    <p>入学日期：</p>
                    <a-input class="input" v-model="info.admissionDate" disabled/>
                </div>
                <div class="input-box">
                    <p>入学方式：</p>
                    <a-input class="input" v-model="info.admissionMode" disabled/>
                </div>
                <div class="input-box">
                    <p>层次：</p>
                    <a-input class="input" v-model="info.level" disabled/>
                </div>
                <div class="input-box">
                    <p>考生来源：</p>
                    <a-input class="input" v-model="info.postgraduateSource" disabled/>
                </div>
                <div class="input-box">
                    <p>学位类别：</p>
                    <a-input class="input" v-model="info.degreeCategory" disabled/>
                </div>
                <div class="input-box">
                    <p>学习形式：</p>
                    <a-input class="input" v-model="info.learningForm" disabled/>
                </div>
                <div class="input-box">
                    <p>学制：</p>
                    <a-input class="input" v-model="info.schoolLength" disabled/>
                </div>
                <div class="input-box">
                    <p>学习地点：</p>
                    <a-input class="input" v-model="info.learningAddress" disabled/>
                </div>
                <div class="input-box">
                    <p>院系编号：</p>
                    <a-input class="input" v-model="info.orgCode" disabled/>
                </div>
                <div class="input-box">
                    <p>院系：</p>
                    <a-input class="input" v-model="info.orgName" disabled/>
                </div>
                <div class="input-box">
                    <p>专业代码：</p>
                    <a-input class="input" v-model="info.courseNo" disabled/>
                </div>
                <div class="input-box">
                    <p>专业名称：</p>
                    <a-input class="input" v-model="info.courseName" disabled/>
                </div>
                <div class="input-box">
                    <p>导师编号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled/>
                </div>
                <div class="input-box">
                    <p>导师姓名：</p>
                    <a-input class="input" v-model="info.teacherName" disabled/>
                </div>
                <div class="input-box">
                    <p>研究方向：</p>
                    <a-input class="input" v-model="info.researchArea" disabled/>
                </div>
                <div class="input-box">
                    <p>联合培养单位：</p>
                    <a-input class="input" v-model="info.uionTrainingUnit" disabled/>
                </div>
                <div class="input-box">
                    <p>是否联合培养：</p>
                    <a-input class="input" :value="info.isUionTrain?'是':'否'" disabled/>
                </div>
                <div class="input-box">
                    <p>是否交叉学科：</p>
                    <a-input class="input" :value="info.isInterdisciplinarySubject?'是':'否'" disabled/>
                </div>
                <div class="input-box">
                    <p>预计毕业日期：</p>
                    <a-input class="input" v-model="info.expectGraduationDate" disabled/>
                </div>
                <div class="input-box">
                    <p>毕结业日期：</p>
                    <a-input class="input" v-model="info.realGraduationDate" disabled/>
                </div>
                <div class="input-box">
                    <p>结束学业日期：</p>
                    <a-input class="input" v-model="info.completionDate" disabled/>
                </div>
                <div class="input-box">
                    <p>就业类别：</p>
                    <a-input class="input" v-model="info.employmentCategory" disabled/>
                </div>
                <div class="input-box">
                    <p>定向就业单位：</p>
                    <a-input class="input" v-model="info.targetEmploymentUnit" disabled/>
                </div>
                <div class="input-box">
                    <p>准考证号：</p>
                    <a-input class="input" v-model="info.admissionNumber" disabled/>
                </div>
                <div class="input-box">
                    <p>注册日期：</p>
                    <a-input class="input" v-model="info.registerDate" disabled/>
                </div>
                <div class="input-box">
                    <p>注册状态：</p>
                    <a-input class="input" v-model="info.registerStatus" disabled/>
                </div>
                <div class="input-box">
                    <p>学籍状态：</p>
                    <a-input class="input" v-model="info.studentStatus" disabled/>
                </div>
                <div class="input-box">
                    <p>学业状态：</p>
                    <a-input class="input" v-model="info.academicStatus" disabled/>
                </div>
                <div class="input-box">
                    <p>在册状态：</p>
                    <a-input class="input" :value="info.registeredStatus?'是':'否'" disabled/>
                </div>
                <div class="input-box">
                    <p>最长学习年限：</p>
                    <a-input class="input" v-model="info.maxStudyYear" disabled/>
                </div>
                <div class="input-box">
                    <p>是否提前毕业：</p>
                    <a-input class="input" :value="info.isEaryGraduation?'是':'否'" disabled/>
                </div>
                <div class="input-box">
                    <p>剩余发放次数：</p>
                    <a-input class="input" v-model="info.remainingDistributionTimes" disabled/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { info } from '@/baseAPI/master/student'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{},
                year:'',
                permissions:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)

            info(this.$route.query.id).then(res=>{
                this.info=res.data;
            })
            

        },
        methods:{

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }
</style>
